import styled from 'styled-components';

export const Container = styled.div`
`;

export const HeaderContainer = styled.div`
  display: flex; 
  justify-content: space-between;
  background-color: #f5f5f5;
  padding: 5px 10px;
  font-weight: bold;
`;

export const ShippingLineNumber = styled.div`
`;

export const ShippingLineCarrier = styled.div`
  display: flex;
  align-items: center;
`;

export const CarrierIdentification = styled.div`
`;

export const CarrierChangeButton = styled.button`
  margin-left: 10px;
  border: 1px solid #c26c0a;
  border-radius: 5px;
`;

export const BodyContainer = styled.div`
  border: 1px solid #f5f5f5;
  padding: 10px;
`;